import { defaultShippingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultShippingAddress";
import { css } from "styled-components";

Object.assign(defaultShippingAddressStyles, {
    ...defaultShippingAddressStyles,
    customerSelectorModalCancelButton: {
        css: css`
            background-color: #999;
            border: none;
            :hover {
                background-color: #999;
            }
        `,
    },
});
